
export class RequestStatus {

    private iconStatus:any = {
        '-1' : {
          icon : 'times',
          class : 'rejected'
        },
        '2' : {
          icon : 'check',
          class : 'approved'
        },
        '1' : {
          icon : 'hourglass-start',
          class : 'pending'
        }
    };
    

    constructor() {
        
    }

    getIcons(){
        return this.iconStatus;
    }
}